import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Grid,
  Tab,
  Tabs,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  FilterSection,
  QuickTalesTable,
  SearchBar,
} from "../../components/components";
import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import {
  drawerWidth,
  mainLayoutStyles,
  showNotification,
} from "../../../../../constants";
import { useQuickTalesContext } from "../../../../../providers/OrganizationAdmin/QuickTalesProvider";
import { useOrganizationContext } from "../../../../../providers/OrganizationAdmin/OrganizationProvider";
import {
  deleteQuickTale,

  duplicateQuickTale,
  quickTalesSearch,
  updateQuickTale,
} from "../../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { useAuth } from "../../../../../hooks";
import { Toast } from "../../../../../common/alert";
import { getFilterQuickTales } from "../../hooks/GAQuickTalesHooks";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../../common/FilterModalComponent";
import { getDateRange } from "../../../../../modules/OrgProf/hook/Organizationhook";
import { GeoPoint, serverTimestamp } from "firebase/firestore";
import VisionMigrationPanel from "../../components/VisionMigrationPanel/VisionMigrationPanel";
import {
  runSearchIndexBackfill,
  runListenCountBackfill,
} from "../../hooks/GASearchIndexHooks";
import SearchLabPanel from "../../components/SearchLabPanel/SearchLabPanel";
import FeedLabPanel from "../../components/FeedLabPanel/FeedLabPanel";
import OrgPrioritiesPanel from "../../components/OrgPrioritiesPanel/OrgPrioritiesPanel";


const GAQuickTalesContainer = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { handleGetGAQuickTales, GAQuickTales, setLoading, loading } =
    useQuickTalesContext();
  const { allOrganization, handleGetAllOrganizations } = useOrganizationContext();

  const [quickTalesData, setQuickTalesData] = useState([]);

  // Tabs: 0 = QuickTales, 1 = Search Lab, 2 = Feed Lab, 3 = Organization Priorities.
  const [activeTab, setActiveTab] = useState(0);

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [whoCanListenFilterOptions, setWhoCanListenFilterOptions] = useState(
    []
  );
  const [creationDateFilterOptions, setCreationDateFilterOptions] = useState(
    []
  );
  const [reportedStatusFilterOptions, setReportedStatusFilterOptions] =
    useState([]);

  // Search-index backfill (AddSearch replacement). See
  // docs/ADDSEARCH_REPLACEMENT_PLAN.md (Phase 1.6).
  const [backfillRunning, setBackfillRunning] = useState(false);
  const [backfillStatus, setBackfillStatus] = useState("");

  // Listen-count backfill from userActivity play_duration events (Phase 4).
  const [listenBackfillRunning, setListenBackfillRunning] = useState(false);
  const [listenBackfillStatus, setListenBackfillStatus] = useState("");

  const handleBackfillListenCounts = async (dryRun) => {
    if (listenBackfillRunning) return;
    setListenBackfillRunning(true);
    setListenBackfillStatus(dryRun ? "Dry run…" : "Backfilling…");
    try {
      const result = await runListenCountBackfill({
        dryRun,
        onProgress: ({ pages, processed, counted, quicktales }) => {
          setListenBackfillStatus(
            `${dryRun ? "Dry run" : "Backfilling"} — ${processed} event(s) scanned, ${counted} play(s) across ${quicktales} quicktale(s) over ${pages} page(s)…`
          );
        },
      });
      const summary = dryRun
        ? `Dry run complete — ${result.counted} play(s) across ${result.quicktales} quicktale(s); ${result.applied} would update, ${result.missing} missing.`
        : `Listen counts backfilled — ${result.applied} quicktale(s) updated from ${result.counted} play(s) (${result.missing} missing).`;
      setListenBackfillStatus(summary);
      Toast("success", summary);
    } catch (error) {
      console.error("backfillListenCounts failed:", error);
      setListenBackfillStatus(`Failed: ${error.message}`);
      Toast("error", `Listen-count backfill failed: ${error.message}`);
    } finally {
      setListenBackfillRunning(false);
    }
  };

  const handleRebuildSearchIndex = async (dryRun) => {
    if (backfillRunning) return;
    setBackfillRunning(true);
    setBackfillStatus(dryRun ? "Dry run…" : "Rebuilding…");
    try {
      const result = await runSearchIndexBackfill({
        dryRun,
        docType: "all",
        onProgress: ({ processed, pages, byType }) => {
          const parts = Object.entries(byType)
            .map(([k, v]) => `${k}: ${v}`)
            .join(", ");
          setBackfillStatus(
            `${dryRun ? "Dry run" : "Rebuilding"} — ${processed} processed (${parts}) over ${pages} page(s)…`
          );
        },
      });
      const parts = Object.entries(result.byType)
        .map(([k, v]) => `${k}: ${v}`)
        .join(", ");
      const summary = `${dryRun ? "Dry run complete" : "Search index rebuilt"} — ${result.processed} item(s) (${parts}).`;
      setBackfillStatus(summary);
      Toast("success", summary);
    } catch (error) {
      console.error("rebuildSearchIndex failed:", error);
      setBackfillStatus(`Failed: ${error.message}`);
      Toast("error", `Search index rebuild failed: ${error.message}`);
    } finally {
      setBackfillRunning(false);
    }
  };

  useEffect(() => {
    // if (GAQuickTales?.length) {
    // } else {
    //   handleGetGAQuickTales();
    // }
    handleGetGAQuickTales();
    // Load organizations so we can resolve org-created "Created By" names.
    if (!allOrganization || allOrganization.length === 0) {
      handleGetAllOrganizations();
    }
  }, []);

  useEffect(() => {
    setQuickTalesData(GAQuickTales);
  }, [GAQuickTales]);


  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  const handleDeleteQuickTale = async () => {
    try {
      setLoading(true);

      selected.forEach(async (item) => {
        let responseTemp = await deleteQuickTale(item);
        console.log("delete quicktale response:", responseTemp);
      });
      await handleGetGAQuickTales();
      setSelected([]);
      showNotification("QuickTale deleted successfully.");
      // Toast("success", "QuickTale deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting quicktale", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  const handleUpdateQuickTaleStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        isDraft: status,
        updatedAt: serverTimestamp(),
        updatedBy: currentUser?.id,

        // status,
        // approvalStatus: {
        //   status: status,
        //   updatedAt: serverTimestamp(),
        //   updatedBy: currentUser?.id,
        // },
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateQuickTale(item, dataTemp);
        console.log("update quicktale response:", responseTemp);
      });
      await handleGetGAQuickTales();
      setSelected([]);
      showNotification("QuickTale updated successfully.");
      // Toast("success", "QuickTale updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating quicktale", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateQuickTaleApprovalStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status,
        updatedAt: serverTimestamp(),
        updatedBy: currentUser?.id,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateQuickTale(item, dataTemp);
        console.log("update quicktale response:", responseTemp);
      });
      await handleGetGAQuickTales();
      setSelected([]);
      showNotification("QuickTale updated successfully.");
      // Toast("success", "QuickTale updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating quicktale", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateQuickTaleReportedStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        reportedStatus: status,
        updatedAt: serverTimestamp(),
        updatedBy: currentUser?.id,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateQuickTale(item, dataTemp);
        console.log("update quicktale response:", responseTemp);
      });
      await handleGetGAQuickTales();
      setSelected([]);
      showNotification("QuickTale updated successfully.");
      // Toast("success", "QuickTale updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating quicktale", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDuplicateQuickTales = async () => {
    try {
      setLoading(true);

      await Promise.all(selected.map((qtId) => duplicateQuickTale(qtId)));
      await handleGetGAQuickTales();
      setSelected([]);
      showNotification("QuickTale(s) duplicated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error duplicating quicktale", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterQuickTales = async () => {
    let creationDateRange;
    if (creationDateFilterOptions && creationDateFilterOptions.length > 0) {
      creationDateRange = getDateRange(
        creationDateFilterOptions,
        "Creation Date"
      );
    }

    // console.log("date::", creationDateFilterOptions)
    setSelected([]);
    if (
      whoCanListenFilterOptions.length > 0 ||
      statusFilterOptions.length > 0 ||
      reportedStatusFilterOptions.length > 0 ||
      creationDateFilterOptions.length > 0
    ) {
      let temp = await getFilterQuickTales(
        whoCanListenFilterOptions,
        statusFilterOptions,
        reportedStatusFilterOptions,
        // creationDateFilterOptions,
        creationDateRange,
        setLoading,
        handleFilterModalClose
      );
      console.log("filter data:", temp);
      setQuickTalesData(temp);
    }
    if (
      whoCanListenFilterOptions.length === 0 &&
      statusFilterOptions.length === 0 &&
      reportedStatusFilterOptions.length === 0 &&
      creationDateFilterOptions.length === 0
    ) {
      setQuickTalesData(GAQuickTales);
    }
  };

  // Function to handle chip deletion
  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "creationDate") {
      setCreationDateFilterOptions([]);
      // setCreationDateFilterOptions((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
    } else if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "whoCanListen") {
      setWhoCanListenFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "reportedStatus") {
      setReportedStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    }
  };

  useEffect(() => {
    handleFilterQuickTales();
  }, [
    whoCanListenFilterOptions,
    statusFilterOptions,
    reportedStatusFilterOptions,
    creationDateFilterOptions,
    // handleDeleteChip
  ]);

  const resetFilter = async () => {
    setReportedStatusFilterOptions([]);
    setWhoCanListenFilterOptions([]);
    setCreationDateFilterOptions([]);
    setStatusFilterOptions([]);
    setQuickTalesData(GAQuickTales);
    setSelected([]);
  };

  const handleSearchQuickTales = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let quicktalesSearchTemp = await quickTalesSearch(GAQuickTales, value);
        setQuickTalesData(quicktalesSearchTemp);
      } else {
        setQuickTalesData(GAQuickTales);
      }
    } catch (error) {
      console.log("error searching quicktales:", error.message);
    }
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };
/* Goes after QuickTalesTable - <VisionMigrationPanel selected={selected} /> */
  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header mainTitle={"QuickTales"} bgColor="#fff" />
      <GeneralAdminSidebar />
      {activeTab === 0 && (
        <Button
          variant="contained"
          onClick={() => navigate("/general-admin/quicktales/create")}
          sx={{
            position: "absolute",
            top: 20,
            right: 40,
            backgroundColor: "#00bcd4",
            color: "#fff",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 600,
            padding: "10px 24px",
            "&:hover": {
              backgroundColor: "#00acc1",
            },
            zIndex: 3000,
          }}
        >
          Create QuickTale
        </Button>
      )}
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>

          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{
              borderBottom: "1px solid #e0e0e0",
              mb: 2,
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
            }}
          >
            <Tab label="QuickTales" />
            <Tab label="Search Lab" />
            <Tab label="Feed Lab" />
            <Tab label="Organization Priorities" />
          </Tabs>

          {/* Tab 0 — QuickTales */}
          <Box hidden={activeTab !== 0}>
            <FilterSection
              handleFilterModalOpen={handleFilterModalOpen}
              statusFilterOptions={statusFilterOptions}
              whoCanListenFilterOptions={whoCanListenFilterOptions}
              reportedStatusFilterOptions={reportedStatusFilterOptions}
              creationDateFilterOptions={creationDateFilterOptions}
              handleDeleteChip={handleDeleteChip}
            />
            <SearchBar
              selected={selected}
              setSelected={setSelected}
              handleDuplicateQuickTales={handleDuplicateQuickTales}
              handleUpdateQuickTaleStatus={handleUpdateQuickTaleStatus}
              handleUpdateQuickTaleApprovalStatus={
                handleUpdateQuickTaleApprovalStatus
              }
              handleUpdateQuickTaleReportedStatus={
                handleUpdateQuickTaleReportedStatus
              }
              handleDeleteQuickTale={handleDeleteModalOpen}
              handleSearch={handleSearchQuickTales}
            />

            <QuickTalesTable
              selected={selected}
              setSelected={setSelected}
              quickTalesData={quickTalesData}
              organizationsData={allOrganization}
            />
          </Box>

          {/* Tab 1 — Search Lab */}
          {activeTab === 1 && (
            <Box>
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  backgroundColor: "#fafafa",
                }}
              >
                <Box sx={{ fontWeight: 600, mb: 0.5 }}>
                  Search Index (Listen / Search)
                </Box>
                <Box sx={{ fontSize: 13, color: "#666", mb: 1.5 }}>
                  Rebuild the in-house search index for all QuickTales and
                  Albums. Use “Dry Run” first to preview counts without writing.
                </Box>
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    disabled={backfillRunning}
                    onClick={() => handleRebuildSearchIndex(true)}
                    sx={{ textTransform: "none" }}
                  >
                    Dry Run
                  </Button>
                  <Button
                    variant="contained"
                    disabled={backfillRunning}
                    onClick={() => handleRebuildSearchIndex(false)}
                    sx={{ textTransform: "none" }}
                  >
                    {backfillRunning ? "Rebuilding…" : "Rebuild Search Index"}
                  </Button>
                  {backfillRunning && <CircularProgress size={20} />}
                </Box>
                {backfillStatus && (
                  <Box sx={{ mt: 1.5, fontSize: 13, color: "#333" }}>
                    {backfillStatus}
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  backgroundColor: "#fafafa",
                }}
              >
                <Box sx={{ fontWeight: 600, mb: 0.5 }}>
                  Listen Counts (from play events)
                </Box>
                <Box sx={{ fontSize: 13, color: "#666", mb: 1.5 }}>
                  Recompute each QuickTale's <code>listenCount</code> and{" "}
                  <code>totalListenSeconds</code> from{" "}
                  <code>userActivity</code> “play_duration” events. Writes
                  absolute totals (safe to re-run); the search index refreshes
                  automatically. Use “Dry Run” first to preview counts.
                </Box>
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    disabled={listenBackfillRunning}
                    onClick={() => handleBackfillListenCounts(true)}
                    sx={{ textTransform: "none" }}
                  >
                    Dry Run
                  </Button>
                  <Button
                    variant="contained"
                    disabled={listenBackfillRunning}
                    onClick={() => handleBackfillListenCounts(false)}
                    sx={{ textTransform: "none" }}
                  >
                    {listenBackfillRunning
                      ? "Backfilling…"
                      : "Backfill Listen Counts"}
                  </Button>
                  {listenBackfillRunning && <CircularProgress size={20} />}
                </Box>
                {listenBackfillStatus && (
                  <Box sx={{ mt: 1.5, fontSize: 13, color: "#333" }}>
                    {listenBackfillStatus}
                  </Box>
                )}
              </Box>

              <SearchLabPanel />
            </Box>
          )}

          {/* Tab 2 — Feed Lab */}
          {activeTab === 2 && <FeedLabPanel />}

          {/* Tab 3 — Organization Priorities */}
          {activeTab === 3 && <OrgPrioritiesPanel />}
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteQuickTale}
        title={"Are you sure to delete the selected QuickTale(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterQuickTales}
        data={[
          {
            mainOptions: creationDateFilterOptions,
            setMainOptions: setCreationDateFilterOptions,
            type: "date",
            title: "Creation Date",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: whoCanListenFilterOptions,
            setMainOptions: setWhoCanListenFilterOptions,
            type: "text",
            title: "Who Can Listen",
            currentOptions: [
              { label: "All", selected: true },
              { label: "public", selected: false },
              { label: "private", selected: false },
              { label: "unlisted", selected: false },
              // { label: "draft", selected: false },
            ],
          },
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "QT Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Draft", selected: false },
              { label: "Finished", selected: false },
              // { label: "approved", selected: false },
              // { label: "pending", selected: false },
              // { label: "denied", selected: false },
              // { label: "removed", selected: false },
            ],
          },
          {
            mainOptions: reportedStatusFilterOptions,
            setMainOptions: setReportedStatusFilterOptions,
            type: "text",
            title: "Reported Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "reported", selected: false },
              { label: "in review", selected: false },
              { label: "pending", selected: false },
              { label: "resolved", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default GAQuickTalesContainer;
